module.exports = __webpack_public_path__ + "static/media/bg-desk-3.65cca0c8.jpg";